import { Reveal } from '@progress/kendo-react-animation';
import { Button } from '@progress/kendo-react-buttons';
import React from 'react';
import { ChevronDownOutline, ChevronUpOutline } from '../../../../../../icons/icons';
import MarkerText from '../../../../../components/inputs/MarkerText';
import { useSearchContext } from '../../../context/SettingsSearchContext';

export default function SettingsExpandableElement(props: { name: string; hint?: string; children?: React.ReactNode }) {
    const context = useSearchContext();
    const [expanded, setExpanded] = React.useState(false);
    return (
        <div className="d-flex flex-column px-3 justify-content-center">
            <div
                className="flex-shrink-0 d-flex align-items-center justify-content-between"
                style={{ minHeight: 48 }}
                onClick={() => setExpanded(!expanded)}>
                <div>
                    <MarkerText highlight={context.term}>{props.name}</MarkerText>
                    <MarkerText highlight={context.term} className="secondary-text">
                        {props.hint}
                    </MarkerText>
                </div>
                <Button svgIcon={expanded ? ChevronUpOutline : ChevronDownOutline} className="button-small" fillMode={'flat'} />
            </div>
            <Reveal>
                {expanded && (
                    <>
                        <div className="p-2 border-top">{props.children}</div>
                    </>
                )}
            </Reveal>
        </div>
    );
}
